import { memo } from 'react';

import { IconIntegration } from '@components/icons/integration';
import { SquareImage } from '@components/square-image';

import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

const ACTION_TYPE = ACTION_TYPES.integration;

export const Node = memo((node: TravellerJourneyNode<typeof ACTION_TYPE>) => {
  const integration = node.data.integration;
  const endpointName = integration?.name ?? getActionLabel(ACTION_TYPE);
  const integrationName = integration?.integrationName;

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={endpointName}
        subLabel={integrationName}
        descriptionText={node.data?.description}
        icon={
          integration?.thumbnail ? (
            <SquareImage src={integration.thumbnail} />
          ) : (
            <IconIntegration color="green200" />
          )
        }
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});
